import React from 'react';
import { processSteps } from '../../data/firm';
interface ProcessTimelineProps {
  surface?: 'porcelain' | 'limestone';
}
export function ProcessTimeline({
  surface = 'porcelain'
}: ProcessTimelineProps) {
  const bg = surface === 'porcelain' ? 'bg-porcelain' : 'bg-limestone';
  return <ol className="relative" data-id="element-440" data-mp="3q4un1f11rvl0">
      {processSteps.map((step, index) => {
      const last = index === processSteps.length - 1;
      return <li key={step.title} className={`relative grid grid-cols-[3rem_1fr] gap-5 ${last ? '' : 'pb-10'}`} data-id="element-441" data-mp="2tfws9wtarxnu" data-mpi={index}>
            <div className="relative flex justify-center" data-id="element-442" data-mp="2yb2d0sayr6ac">
              <span className={`relative z-10 flex h-12 w-12 items-center justify-center rounded-full border border-copper/50 ${bg} font-display text-sm font-semibold text-copper-deep`} data-id="element-443" data-mp="32dp60wjdex94">
                {String(index + 1).padStart(2, '0')}
              </span>
              {!last && <span className="absolute bottom-0 top-12 w-px bg-copper/30" aria-hidden="true" data-id="element-444" data-mp="2eo4ehp95iro8" />}
            </div>
            <div className="pt-2.5" data-id="element-445" data-mp="39bdk37tjaq4n">
              <h3 className="text-lg font-semibold text-aubergine" data-id="element-446" data-mp="34ctumxfqew7j">{step.title}</h3>
              <p className="mt-2 max-w-prose leading-relaxed text-plum/70" data-id="element-447" data-mp="34ews22j7rrma">{step.description}</p>
            </div>
          </li>;
    })}
    </ol>;
}